import React from 'react';
import './index.css';


const   Project = () =>{
    return(
        <div className='Blog'>
            {/* <div className='narbar'>
                <img src ='./images/logo2.png'alt='l'></img>
                <p>Home</p>
                <p>Videos</p>
                <p><a href="#Blog">Blog</a></p>
                <p>Podcast</p>
                <p>Portfolio</p>
                
                
            </div> */}
            <div className='book'>
                <p>Welcome to Born a crime a very intersting and interactive book.</p>
            </div>
            <div className='Trevour'>
                <h6>Born a Crime by Trevor Noah</h6>
            </div>
            <img className='Born-crime' src ='./images/B2.png'alt='l'></img>
            <div className='Introduction'>
           <h4>A blog for Born a Crime</h4>
                <p>Trevor Noah's book, "Born a Crime," is important because it talks about social, political, and economic issues. The book is about <br/>
                Noah's life in South Africa during apartheid. His mother was black and his father     
                 was white, which was illegal at the time.
                </p>
            </div>
            <br></br>
            <br></br>
            
<div className='Relevants'>
            <div className='Social-economic' >
                <h1>Social Relevance</h1>
                <p>"Born a Crime" is relevant because it talks about race, identity, 
                and belonging. Noah's story shows how complicated race
                 is in South Africa and how apartheid still affects society.
                  This is important today because many countries are dealing with
                   racism, discrimination, and inequality. Noah's story reminds us
                    how important it is to understand each other. 
</p>
                </div> 
                <div className='Economic'>
                    <h2>Economic Relevance</h2>
                    <p>"Born a Crime" talks about poverty and opportunity. Noah grew up poor
                    which shows the bigger problem of economic differences and access to resources.
                     His journey from poverty to success shows how education and hard work matter. This
                      is still important in today's discussions about economic power and help for everyone."
</p>
                </div>
                <div className='Political'>
                    <h3>Political Relevance</h3>
                    <p>From a political view, "Born a Crime" gives insight into power and resistance.
                     Noah talks about the challenges of making a fair society after apartheid. His thoughts
                      on leadership and change relate to today's talks about democracy and human rights. Economic
                       Relevance: 
</p>
                </div>
                </div>
                <br></br>
                <br></br>
                <div className='Conclusion'>
                <p>In conclusion, the book "Born a Crime" by Trevor Noah provides valuable insights
                 into various social, political, and economic issues that continue to shape our world today.
                  By sharing his personal story in the context of his injustices and challenges, Noah encourages     
                   us to think about their roles in creating a fairer and more just society.
                 </p>
                </div>
        </div>

    )

        

        }
        
        
        export default Project;